import React, { useState } from 'react';
import { login } from '../../utils';
import { useHistory } from 'react-router';
import { useAuthContext } from '../../contexts/Auth';
import { Auth } from 'aws-amplify';
import { useOnboardingContext } from '../../contexts/Onboarding';
import Layout from '../../components/auth/ChangePassword';

export default function ChangePassword() {
  const history = useHistory();
  const [error, setError] = useState(null);
  const { signedIn, signIn, user, setUser } = useAuthContext();
  const { setHasCompletedOnboarding, setActiveStep } = useOnboardingContext();

  return signedIn ? (
    <div />
  ) : (
    <Layout
      error={error}
      onSubmit={async (newPassword) => {
        if (!user) {
          return setError('User is missing.');
        }
        const email = user.challengeParam.userAttributes.email;
        try {
          await Auth.completeNewPassword(user, newPassword, {});
          await login({
            email,
            password: newPassword,
            signIn,
            history,
            setUser,
            setHasCompletedOnboarding,
            setActiveStep,
          });
        } catch (error) {
          setError(error.message);
        }
      }}
    />
  );
}
